let arrayProducts2 = [];
var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    minimumFractionDigits: 2,
    currency: "USD"
});
let trashIcon = $('input[name="trashIcon"]').val();
var errorSintrGif = $('input[name="errorSintrGif-1"]').val();

window.addEventListener('load', function() {
    /**
    * Funcion para posicionar el elemnto status dentro de la tabla solo cuando es version tablet y no existe el elemento volver a comprar
    */
    function statusPosition() {
        const recompraTabletElements = document.querySelectorAll('.recompra-tablet');

        recompraTabletElements.forEach(function(recompraTablet) {
            const pElement = recompraTablet.querySelector('p');

            if (!pElement) {
                const statusSpan = recompraTablet.querySelector('.status');
                if (statusSpan) {
                    statusSpan.classList.remove('pt-3');
                }

                const recompraTblt = recompraTablet.closest('.recompra-tblt');
                if (recompraTblt) {
                    recompraTblt.classList.remove('pt-3');
                }

                const recompraTabletParent = recompraTablet.closest('.recompra-tablet-parent');
                if (recompraTabletParent) {
                    recompraTabletParent.classList.add('py-4');
                }
            }
        });
    }
    /**
    * Funcion para saber el ancho de pantalla y llamar la funcion que posiciona el elemento de status en la tabla
    */
    function handleResize() {
        const sizeScreen = window.innerWidth;
        if (sizeScreen > 768 && sizeScreen < 992) {
            statusPosition();
        }
    }

    handleResize();

    window.addEventListener('resize', handleResize);

    document.querySelectorAll('.select-filter-orders').forEach(function(element) {
        element.addEventListener('change', function() {
            var selectedValue = this.value;
            if (selectedValue) {
                window.location.href = selectedValue;
            }
        });
    });
});


$(".dropdown-menu-account").on("change", function (e) {
    e.stopPropagation();
    const page = this.value;
    // go to page url
    if (page) {
        window.location.href = page;
    }
});

$(".quotes-page").ready(function() {
    var responseError = $("#response-error");
    if (responseError.length > 0 && responseError.val() === "true") {
        let urlParams = new URLSearchParams(window.location.search);
        let errorModal = urlParams.get('errorModal');
        if(errorModal){
            $('body').append(errorModal);
            $('#errorModalGeneric').modal('show');
            let currentUrl = new URL(window.location);
            currentUrl.searchParams.delete('errorModal');
            currentUrl.searchParams.delete('error');
            window.history.replaceState({}, document.title, currentUrl.toString());
            return;
        }
        let msj = $('#error-msj-gral').val();
        $('#quote-in-process').modal("show");
        $('.modal-content').empty();
        $('.modal-content').append(`
            <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
            <p class="mb-3">${msj}</p>
            <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
    }
})

$('#state').change(async function() {
    var selectedOption = $(this).find('option:selected');
    var municipalityNumber = selectedOption.data("municipality");
    const url =$('[data-geolocation-municipios-url]').first().data("geolocationMunicipiosUrl");

    await $.ajax({
        url: url,
        method: 'Get',
        data: {
            'estado': municipalityNumber
        },
        async: true,
        success: function (data) {
            var citySelector = $('.city-selector');
            var municipalities = data.municipios;
            citySelector.empty();
            for (var i = 0; i < municipalities.length; i++) {
                citySelector.append('<option value="' + municipalities[i].municipality + '">' + municipalities[i].municipality + '</option>');
            }
        }
    });
});

$('#changePassword').change(function () {
    if ($(this).is(':checked')) {
        $(".hidden-fields").hide().removeClass("d-none").slideDown("fast");
        $(".change-password-fields input").attr("required", true);
        $(".change-password-fields div").attr("required", true);
    } else {
        $(".hidden-fields").slideUp("fast");
        $(".change-password-fields input").removeAttr("required");
        $(".change-password-fields div").removeAttr("required");
    }
});

$("#acceptAdvertising").on("click", function () {
    $(this).val($(this).is(':checked'));
})

$('#phone').on('input', function () {
    // Remove any character that is not a number
    this.value = this.value.replace(/\D/g, '');
});

$('#firstName, #lastName').on('input', function () {
    // Remove any character that is a number
    this.value = this.value.replace(/[^a-zA-ZÀ-ÿ\u00f1\u00d1\s´`¨^]/g, '');
});

$(document).on('click', '.share-icon, .question-icon', function () {
    let $tooltip = $(this).next(".tooltip-top");

    if ($tooltip.is(":visible")) {
        $tooltip.hide();
    } else {
        $(".tooltip-top").hide();
        $tooltip.show();
    }
});

$(".remove-quote").on("click", function (e) {
    e.preventDefault();
    var quoteId = $(this).data("quote-id");
    var url = $(this).data("url");
    var row = $('.single-quote[data-quote-id="' + quoteId + '"]');
    $.ajax({
        url: url,
        method: 'POST',
        data: {
            'quoteId': quoteId
        },
        success: function (data) {
            if (data.success) {
                row.fadeOut(500, function() {
                    row.remove();
                });
            }
        }
    });
});
/**
    * Creacion de template.
    *
    * @param {response} product - Array de los detalles del producto.
    * @returns {template} Template a renderizar.
    */
function createProductTemplate(product) {
    let unitPrice = formatter.format(Number(product.PRECIOUNITARIO));
    let qtyProd = product.CANTIDAD == 1 ?  "" : "s"
    let galones = false;
    let stringUnit = "";
    if ((product.c_UNITSALES == "Galón" || product.c_UNITSALES == "galón") && product.CANTIDAD !== 1 ) {
        let subStr = product.c_UNITSALES.trim();
        subStr = subStr.substring(0, 3);
        galones = true;
        stringUnit = subStr + "ones";
    }
    if(!galones){
        stringUnit = product.c_UNITSALES ? product.c_UNITSALES : "pieza";
        stringUnit += qtyProd;
    }
    return `
    <div class="d-flex justify-content-between element-with-line align-items-start product-in-list" style="height: 66px">
        <div class="flex-grow-1 mx-0 text-truncate product-name-modal">
            <div class="product-name-text">${product.DESCRIPCION}</div>
            <span class="productos-en-lista">${product.CANTIDAD} ${stringUnit}</span>
        </div>
        <div class="mx-2 box-price">
            <p class="price-total-product m-0">${unitPrice}</p>
        </div>
    </div>` 
};

/** Creacion de template.
*
* @param {response} product - Array de los detalles del producto.
* @returns {template} Template a renderizar.
*/
function createProductOpenList(product) {
    let qtyPzas = product.quantity == 1 ? "" : "s";
    let galones = false;
    let stringUnit = "";
    if ((product.salesUnit == "Galón" || product.salesUnit == "galón") && product.quantity !== 1 ) {
        let subStr = product.salesUnit.trim();
        subStr = subStr.substring(0, 3);
        galones = true;
        stringUnit = subStr + "ones";
    }
    if(!galones){
        stringUnit = product.salesUnit ? product.salesUnit : "pieza";
        stringUnit += qtyPzas;
    }
    return `
        <div class="d-flex justify-content-between align-items-start element-with-line product-in-list" data-pid="${product.productId}" style="height: 66px">
            <!-- Primer elemento: Imagen del producto -->
            <div class="pr-2">
                <img src="${product.image}" style="height: 48px; width: 48px; object-fit: cover;">
            </div>
            <!-- Segundo elemento: Nombre y cantidad de producto -->
            <div class="flex-grow-1 mx-2 text-truncate product-name-modal">
                <div class="product-name-text">${product.name}</div>
                <span class="productos-en-lista">${product.quantity} ${stringUnit}</span>
            </div>
            <!-- Tercer elemento: Costo del producto -->
            <div class="mx-2 box-price">
                <p class="price-total-product m-0">$${product.totalPrice}</p>
            </div>

            <!-- Cuarto elemento: Icono de bote de basura -->
            <div id="deleteProductFromQuoteListProfile" class="text-modal ml-2">
                <img src="${trashIcon}" class="icon-trash" alt="trashIcon">
            </div>
        </div>`    
};

$(".search-quote-button").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    $('#quoteSearchField').trigger($.Event('keydown', { key: 'Enter' }));
});

$('#quoteSearchField').on('keydown', function (event) {
    if (event.key === 'Enter') {
        event.preventDefault();
        let query = $(this).val();
        let url = $('#getQuoteFromStoreOrWeb').val();
        $(this).removeClass('is-invalid');
        $('#error-message').addClass('d-none')
        if (query.trim() === '') {
            $(this).addClass('is-invalid');
            $('#error-message').removeClass('d-none');
        } else {
            let data = {
                folioQuote: query
            }
            $('body').spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                success: function (response) {
                    if(response && response.success && response.monto_total){
                        $(".error-message").empty();
                        $('#response-modal-label').text("Folio de cotización " + response.folio)
                        arrayProducts2.push(response.products);
                        let nameQuote = response.nameList || response.folio;
                        $('#responseModal').data("products", response.products);
                        $('#responseModal').data("monto", response.monto_total);
                        $('#responseModal').data("folio", response.folio);
                        $('#responseModal').data("url-quote", response.url);
                        $('#responseModal').data("name-quote", nameQuote);
                        let products = response.products;
                        let numProduct = $('.numProduct.totals');
                        numProduct.empty();
                        // Agrega dos elementos <p> a numProduct
                        numProduct.append(`<p class="text-modal productos-totales">Lista de productos (${response.totalProducts})</p>`);
                        // eslint-disable-next-line no-useless-concat
                        numProduct.append('<p class="price-grand-total">' + "Total: " + '$' + response.monto_total + '</p>');
                        $('.list-product-add').empty();
                        products.forEach(function(product) {
                            let templateRender = createProductTemplate(product);
                            $('.list-product-add').append(templateRender);
                        });
                        $('#responseModal').modal("show");
                    } else if(response.error && response.success) {
                        $('#error-service-modal').modal("show");
                        $('#error-service').text(response.error);
                    }
                    $.spinner().stop();
                },
                error: function (errorThrown) {
                    $('#responseModal').modal("show");
                    let msj = $('#error-msj-gral').val();
                    $('.modal-content').empty();
                    $('.modal-content').append(`
                        <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                        <p class="mb-3">${msj}</p>
                        <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                    $('#responseModal').on('click','#goNavigate', ()=> {
                        setTimeout(()=> {
                            window.location.reload();
                        },200)
                    });
                    $.spinner().stop();
                }
            });
        }
    }
});

$('#guardar-en-perfil').on('click', function (event) {
    event.preventDefault();
    let url = $('#save-quote').val();
    let monto = $('#responseModal').data("monto");
    let folio = $('#responseModal').data("folio");
    let urlQuote = $('#responseModal').data("url-quote");
    let nameQuote = $('#responseModal').data("name-quote");
    let data = {
        monto: monto,
        folio: folio,
        arrayProd: JSON.stringify(arrayProducts2),
        nameQuote: nameQuote,
        urlQuote: urlQuote
        // prods: JSON.stringify(prods)
    }
    $('#responseModal').spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: data,
        success: function (response) {
            if(response && response.success){
                $('#responseModal').modal("hide");
                window.location.reload();
            } else if(!response.success && response.error){
                $(".error-message").empty();
                let errorText = `<p class="text-danger error-message my-0"> ${response.message}</p>`
                $('.list-product-add').after(errorText);
            }
            $.spinner().stop();
        },
        error: function (errorThrown) {
            let msj = $('#error-msj-gral').val();
            $('.modal-content').empty();
            $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
            $('#responseModal').on('click','#goNavigate', ()=> {
                setTimeout(()=> {
                    window.location.reload();
                },200)
            });
            $.spinner().stop();
        }
    });
});

$('.cotizacion-curso').on('click', function (event) {
    let url = $("#get-open-list").val();
    $('.list-product-add-1').removeClass('is-invalid');
    $('#error-message-empty-product').text('');
    $('body').spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            if(response && response.success && response.detailOpenList) {
                let products = response.detailOpenList.products;
                let nameList = $('.nameList');
                let numProduct = $('.numProduct.totals');
                // $('.list-product-add').removeClass('is-invalid');
                nameList.empty();
                numProduct.empty();
                // Agrega un elemento <p> a nameList
                nameList.append('<p class="name-list">' + response.nameList + '</p>');
                // Agrega dos elementos <p> a numProduct
                numProduct.append(`<p class="productos-totales">Lista de productos (${response.totalProducts})</p>`);
                // eslint-disable-next-line no-useless-concat
                numProduct.append('<p class="price-grand-total">' + "Total: " +'$' + response.grandTotal +'</p>');
                $('.list-product-add-1').empty();
                products.forEach(function(product) {
                    let templateRender = createProductOpenList(product);
                    $('.list-product-add-1').append(templateRender);
                });
            }
            $.spinner().stop();
        },
        error: function (errorThrown) {
            $.spinner().stop();
            let msj = $('#error-msj-gral').val();
            $('#quote-in-process').modal("show");
            $('.modal-content').empty();
            $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
            $('#quote-in-process').on('click','#goNavigate', ()=> {
                setTimeout(()=> {
                    window.location.reload();
                },200)
            });
            $.spinner().stop();
        }
    });
});

$('#quote-in-process').on('click','#generate-quote-from-open-list', function() {
    if($('.list-product-add-1').children().length === 0) {
        $('.list-product-add-1').addClass('is-invalid');
        $('#error-message-empty-product').text('No puedes crear una cotización sin productos.');
        return;
    }
    let url = $('#create-quote').val();
    $('#quote-in-process').spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        success: function (resp) {
            if(resp.blockSale){
                $('#quote-in-process').modal("hide");
                var errorModalGeneric = $('#errorModalGeneric');
                if (!errorModalGeneric.length) {
                    $('body').append(resp.errorModalBlockSale);
                }
                $('#errorModalGeneric').modal('show');
                $.spinner().stop();
                return;
            }
            if(resp && resp.success && resp.folio){
                $('#quote-in-process').modal("hide");
                window.location.reload()
            }else{
                $('#quote-in-process').modal("hide");
                setTimeout(()=>{
                    $('#error-service-modal').modal("show");
                    $('#error-service').text(resp.error);
                },1200)
            }
            $.spinner().stop();
        },
        error: function (errorThrown) {
            $.spinner().stop();
            let msj = $('#error-msj-gral').val();
            $('.modal-content').empty();
            $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
            $('#quote-in-process').on('click','#goNavigate', ()=> {
                setTimeout(()=> {
                    window.location.reload();
                },200)
            });
            $.spinner().stop();
        }
    });
})

$('#quote-in-process').on('click', '#deleteProductFromQuoteListProfile', function() {
    const productContainer = $(this).closest('.product-in-list');
    const productId = productContainer.data('pid');
    const data = {
        productId: productId
    } 
    const url = $('#endpointRemoveItemProfile').val();
    $.ajax({
        url: url,
        data: data,
        type: 'POST',
        success: function(response) {
            if(response && response.success && response.detailOpenList && response.removeItem && response.totalProducts > 0) {
                let quotationName = response.nameList;
                let products = response.detailOpenList.products;
                let nameList = $('.nameList');
                let numProduct = $('.numProduct.totals');
                nameList.empty();
                numProduct.empty();

                // Agrega un elemento <p> a nameList
                nameList.append('<p class="name-list">' + quotationName + '</p>');

                // Agrega dos elementos <p> a numProduct
                numProduct.append(`<p class="productos-totales">Lista de productos(${response.totalProducts})</p>`);
                // eslint-disable-next-line no-useless-concat
                numProduct.append('<p class="price-grand-total">' + "Total: " + '$' + response.grandTotal + '</p>');
                $('.list-product-add-1').empty();
                products.forEach(function(product) {
                    let templateRender = createProductOpenList(product);
                    $('.list-product-add-1').append(templateRender);
                });
            } else {
                $('#quote-in-process').modal('hide');
            }
        },
        error: function() {
            let msj = $('#error-msj-gral').val();
            $('.modal-content').empty();
            $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
            $('#quote-in-process').on('click','#goNavigate', ()=> {
                setTimeout(()=> {
                    window.location.reload();
                },200)
            });
            $.spinner().stop();
        }
    });
});

// input interpass number in customer information section
$('#interpassnumber').on('input', function() {
    var value = $(this).val();
    var newValue = value.replaceAll(/\D/g, '');
    $(this).val(newValue)
    if (value.length > 10) {
        $(this).val(value.substring(0, 10));
    }
    $(".interpass-feedback-error").remove();
});

// find attr name interpassNumber and set it to input on interpassBlock
let interpassNumber = $('[name="interpassNumber"]').val();
if (interpassNumber && interpassNumber !== '') {
    $(".interpass-verify-input").val(interpassNumber);
    $(".interpass-verify-input").attr('readonly', true);
    $('.interpass-verify-button').hide();
    $('.interpass-remove-button').removeClass('d-none');
}

/**
 * Function to verify interpass code
 * @param {string} interpassCode - Código de interpass
 */
async function verifyInterpassCode(interpassCode) {
    const serviceURL = $('[name="validateInterpassCode"]').first().val();
    // return get function passing the interpassCode
    return $.ajax({
        url: serviceURL,
        method: 'GET',
        data: {
            'interpassCode': interpassCode
        },
        async: true,
        success: function (data) {
            return data;
            
        }
    });
}

/**
 * Function to remove interpass code
 */
async function removeInterpassCode() {
    let serviceURL = $('[name="removeInterpassCode"]').first().val();
    return $.ajax({
        url: serviceURL,
        method: 'GET',
        async: true,
        success: function (data) {
            return data;
        }
    });
}

$('.interpass-verify-button').on('click', async function() {
   
    const input = $('.interpass-verify-input');
    const thisInput = $(this).siblings('.interpass-verify-input');
    interpassNumber = thisInput.val();
    $(".interpass-block").spinner().start();

    // validate if interpass number is empty
    if (interpassNumber === '') {
        const dataVoidText = $(".interpass-feedback").data('void');
        $(".interpass-feedback").show("normal").text(dataVoidText);
        $(".interpass-block").spinner().stop();
        return;
    }

    // add disabled to button
    $(this).attr('disabled', true);
    
    $(".interpass-feedback").hide();
    var verifyCode =  await verifyInterpassCode(interpassNumber);
    let blockSale = verifyCode && verifyCode.blockSale;
    if(blockSale){
        var errorModalGeneric = $('#errorModalGeneric');
        if (!errorModalGeneric.length) {
            $('body').append(verifyCode.errorModalBlockSale);
        }
        $('#errorModalGeneric').modal('show');
        $(this).attr('disabled', false);
        $(".interpass-block").spinner().stop();
        return;
    }
    // validate if interpass number is valid
    if (verifyCode && verifyCode.success) {
        const message = verifyCode.message;
        const resultado = message && message.RESULTADO;
        if (resultado === "OK") {
            // set interpass number in input and disable it
            input.val(interpassNumber);
            input.attr('readonly', true);
            // hide verify button and show remove button
            $('.interpass-verify-button').hide();
            $('.interpass-remove-button').removeClass('d-none');
            // show valid feedback
            const validMsg = message.MENSAJEIDVALIDO;
            $('.valid-feedback').text(validMsg).show("normal");

            const customerInfoSection = $('.customer-information-section');
            // set interpass number in customer info section form
            if (customerInfoSection.length > 0) {
                const formInterpassInput = customerInfoSection.find('#interpassnumber');
                formInterpassInput.val(interpassNumber);
            }
        } else {
            // show invalid feedback if interpass number is invalid
            const erroMessage = message.MENSAJE;
            $('.interpass-feedback').text(erroMessage).show("normal");
        }
        $(this).attr('disabled', false);
        $(".interpass-block").spinner().stop();
    } else {
        // show error feedback if service fails
        const erroMessage = "Fallo en el llamado al servicio de interpass";
        $('.interpass-feedback').text(erroMessage).show("normal");
        $(this).attr('disabled', false);
        $(".interpass-block").spinner().stop();
    }
});

$('.interpass-remove-button').find(".icon-trash").on('click', async function() {
  
    let removeCode = await removeInterpassCode();
    if (removeCode && removeCode.success) {

        $('.interpass-verify-input').removeAttr('readonly');
        $('.interpass-verify-input').val('');
        $('.interpass-verify-button').show();
        $('.interpass-remove-button').addClass('d-none');
        // hide valid feedback and invalid feedback
        $('.valid-feedback').hide();
        $('.interpass-feedback').hide();

        const customerInfoSection = $('.customer-information-section');
        // set interpass number in customer info section form
        if (customerInfoSection.length > 0) {
            const formInterpassInput = customerInfoSection.find('#interpassnumber');
            formInterpassInput.val('');
        }
    }
});

/**
  * upgrade mini cart information
  *
*/
function reloadMiniCart() {
    var url = $('.minicart').data('action-url');
    $('.minicart .popover').addClass('show').spinner().start();
    $.get(url, function (data) {
        $('.minicart .popover').empty().append(data);
        $.spinner().stop();
    });
}

$('.recompra-text').on('click', function (e) {
    e.preventDefault();
    $.spinner().start();
    let ticketId = $(this).data('ticketid');
    let url = $(this).data("url");
    let ticketResponseModal = $("#addTicketToCart");
    let modalBody = ticketResponseModal.find(".modal-body");
    let modalFooter = ticketResponseModal.find(".modal-footer");
    $.ajax({
        url: url,
        method: 'GET',
        data: {ticketId: ticketId},
        success: function (data) {
            reloadMiniCart();
            modalBody.find(".product-message").empty();
            if(data.blockSale){
                var errorModalGeneric = $('#errorModalGeneric');
                if (!errorModalGeneric.length) {
                    $('body').append(data.errorModalBlockSale);
                }
                $('#errorModalGeneric').modal('show');
                $.spinner().stop();
                return;
            }
            if (data.ticketResponse) {
                let postsalesAdded = data.postSalesTicketAddedMsg;
                let message = data.ticketMessage.MENSAJE ? data.ticketMessage.MENSAJE : data.ticketMessage.ERROR;
                modalBody.removeClass("text-center");
                modalBody.find("img").addClass("d-none");
                modalBody.find(".response-message").text(!data.postsalesAdded ? message : postsalesAdded);
                if (data.toCartButtons) {
                    modalFooter.find(".go-to-cart").removeClass("d-none");
                    modalFooter.find(".continue-button").removeClass("btn-primary").addClass("btn-outline-primary").text($(".error-conection-message").data("continue-button"));
                } else {
                    modalFooter.find(".go-to-cart").addClass("d-none");
                    modalFooter.find(".continue-button").removeClass("btn-outline-primary").addClass("btn-primary").text($(".error-conection-message").data("default-text"));
                }
                if (data.ticketMessage.PARTIDAS && data.ticketMessage.PARTIDAS.length > 0 && !data.postsalesAdded) {
                    modalBody.find(".product-message").html(data.ticketMessage.ticketProductHtml);
                }
                // Show or hide quantity number in minicart icon
                if (data.quantityTotal > 0){
                    $('.minicart-quantity').empty().append(data.quantityTotal);
                    $(".minicart-quantity").removeClass("d-none");       
                } else {
                    $(".minicart-quantity").addClass("d-none");
                }
            } else {
                modalBody.addClass("text-center");
                modalBody.find(".response-message").text(data.responseError);
                modalBody.find("img").removeClass("d-none");
                modalFooter.find(".go-to-cart").addClass("d-none");
                modalFooter.find(".continue-button").removeClass("btn-outline-primary").addClass("btn-primary").text($(".error-conection-message").data("default-text"));
            }
            $.spinner().stop();
            ticketResponseModal.modal("show");
        },
        error: function (error) {
            $.spinner().stop();
            modalBody.find("img").removeClass("d-none");
            modalBody.find(".response-message").text($(".error-conection-message").val());
            modalBody.find(".product-message").empty();
            modalBody.addClass("text-center");
            modalFooter.find(".go-to-cart").addClass("d-none");
            modalFooter.find(".continue-button").removeClass("btn-outline-primary").addClass("btn-primary").text($(".error-conection-message").data("default-text"));
            ticketResponseModal.modal("show");
        }
    })
})

$(".icon-eye").on("click", function (e) {
    $.spinner().start();
});
